// src/utils/saveExercise.js
import { db } from "../config/firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  doc,
  deleteDoc,
  query,
  where,
  getDocs,
} from "firebase/firestore";

export const saveExercise = async (user, exercise) => {
  if (!user) throw new Error("User not authenticated.");

  const savedRef = collection(db, "savedExercises");

  // Step 1: Query to check for existing saved version
  const q = query(
    savedRef,
    where("userId", "==", user.uid),
    where("exerciseId", "==", exercise.id) // ✅ use a dedicated field name
  );
  const existing = await getDocs(q);

  if (!existing.empty) {
    return null; // Already saved
  }

  // Step 2: Save it
  const exerciseData = {
    exerciseId: exercise.id,   // ✅ store exercise.id explicitly
    userId: user.uid,
    savedAt: serverTimestamp(),
    ...exercise,               // spread last so we keep all metadata
  };

  const docRef = await addDoc(savedRef, exerciseData);
  return docRef.id;
};

export const unsaveExercise = async (user, exerciseId) => {
  if (!user?.uid || !exerciseId) return;

  try {
    const savedRef = collection(db, "savedExercises");
    const q = query(
      savedRef,
      where("userId", "==", user.uid),
      where("exerciseId", "==", exerciseId) // ✅ match on stored field
    );

    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      console.warn("No matching saved exercise found to delete.");
      return;
    }

    const deletePromises = snapshot.docs.map((docSnap) =>
      deleteDoc(doc(db, "savedExercises", docSnap.id))
    );

    await Promise.all(deletePromises);
  } catch (err) {
    console.error("Failed to unsave exercise:", err);
    throw err;
  }
};
